import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import styles from './styles.module.scss'

import { getAssetsSuppliers, getAssetsAssigns } from '../../../../api'

import InputSelect from '../../../Core/InputSelect'
import Input from '../../../Core/Input/Input'

const AssetFilters = ({companyId, filters, sections, onChange}) => {
  const { t } = useTranslation()
  const { categories, ownerships, places } = useSelector(state => state.asset.options)

  const [suppliers, setSuppliers] = useState([])
  const [assigns, setAssigns] = useState([])

  useEffect(() => {
    getOptions()
  }, [companyId])

  const getOptions = async () => {
    const [suppliersRes, assignsRes] = await Promise.all([
      getAssetsSuppliers(companyId),
      getAssetsAssigns(companyId)
    ])
    if (Array.isArray(suppliersRes)) {
      setSuppliers(suppliersRes.map(s => ({id: s, name: s})))
    }
    if (Array.isArray(assignsRes)) {
      setAssigns(assignsRes)
    }
  }

  const handleChange = e => {
    const { name, value } = e.target
    onChange({[name]: value})
  }

  const statusOptions = [
    { id: 'all', name: t('All statuses') },
    { id: 'available', name: t('Available') },
    { id: 'damaged', name: t('Damaged') },
    { id: 'lost', name: t('Lost') },
    { id: 'maintenance', name: t('Maintenance') },
    { id: 'reserved', name: t('Reserved') },
  ]
  
  const maintenanceOptions = [
    { id: 'all', name: t('Any maintenance') },
    { id: 'overdue', name: t('Maintenance overdue') },
    { id: '30_days', name: t('Due within 30 days') },
    { id: 'workshop', name: t('In workshop') },
    { id: 'no_plan', name: t('No maintenance plan') },
  ]
  
  const scanAgeOptions = [
    { id: 'all', name: t('Any scan age') },
    { id: 'recently', name: t('Recently scanned') },
    { id: '7_days', name: t('Not scanned 7+ days') },
    { id: '30_days', name: t('Not scanned 30+ days') },
    { id: '90_days', name: t('Not scanned 90+ days') },
    { id: 'never', name: t('Never scanned') },
  ]

  const filterOptions = {
    categories: [{id: 'all', name: t('All categories')}, ...categories],
    ownerships: [{id: 'all', name: t('All ownerships')}, ...ownerships],
    statuses: statusOptions,
    assigned: [{id: 'all', name: t('All assigned')}, {id: 'assigned', name: t('Anyone assigned')}, {id: 'unassigned', name: t('Unassigned')}, ...assigns],
    places: [{id: 'all', name: t('All places')}, ...places],
    suppliers: [{id: 'all', name: t('All suppliers')}, ...suppliers],
    maintenance: maintenanceOptions,
    scanAge: scanAgeOptions,
  }

  return (
    <div className={styles.container}>
      {
        sections.search
          ? <Input
              id='search'
              name='search'
              type='text'
              placeholder={t('Search by name')}
              value={filters.search}
              onChange={handleChange}
              fullWidth
            />
          : null
      }
      {
        sections.category
          ? <InputSelect
              id='category'
              options={filterOptions.categories}
              value={filters.category}
              name='category'
              onChange={handleChange}
              valueKey='id'
              labelKey='name'
            />
          : null
      }
      {
        sections.ownership
          ? <InputSelect
              id='ownership'
              options={filterOptions.ownerships}
              value={filters.ownership}
              name='ownership'
              onChange={handleChange}
              valueKey='id'
              labelKey='name'
            />
          : null
      }
      {
        sections.status
          ? <InputSelect
              id='status'
              options={filterOptions.statuses}
              value={filters.status}
              name='status'
              onChange={handleChange}
              valueKey='id'
              labelKey='name'
            />
          : null
      }
      {
        sections.assigned
          ? <InputSelect
              id='assigned'
              options={filterOptions.assigned}
              value={filters.assigned}
              name='assigned'
              onChange={handleChange}
              valueKey='id'
              labelKey='name'
            />
          : null
      }
      {
        sections.place
          ? <InputSelect
              id='place'
              options={filterOptions.places}
              value={filters.place}
              name='place'
              onChange={handleChange}
              valueKey='id'
              labelKey='name'
            />
          : null
      }
      {
        sections.supplier
          ? <InputSelect
              id='supplier'
              options={filterOptions.suppliers}
              value={filters.supplier}
              name='supplier'
              onChange={handleChange}
              valueKey='id'
              labelKey='name'
            />
          : null
      }
      {
        sections.maintenance
          ? <InputSelect
              id='maintenance'
              options={filterOptions.maintenance}
              value={filters.maintenance}
              name='maintenance'
              onChange={handleChange}
              valueKey='id'
              labelKey='name'
            />
          : null
      }
      {
        sections.scanAge
          ? <InputSelect
              id='scanAge'
              options={filterOptions.scanAge}
              value={filters.scanAge}
              name='scanAge'
              onChange={handleChange}
              valueKey='id'
              labelKey='name'
            />
          : null
      }
    </div>
  )
}

export default AssetFilters
